/**
 * Persist specific properties of the store state
 *
 * @param state Current Global state
 * @return Partial state to persist
 */
export default (state: IKeyValue) => ({
	lastOpened: state.lastOpened,
	token: state.token,
});
